<app-iota-modal [modalOptions]="modalOptions" (close$)="close()">
    <h5 modal-header>{{ data?.title || 'Dokumente hochladen' }}</h5>
    <div modal-body class="p-5 flex flex-col gap-3">
        <p *ngIf="data?.text" class="my-2">{{ data?.text }}</p>

        <input
            hidden
            type="file"
            [multiple]="data?.multiple || false"
            #fileDropRef
            id="fileDropRef"
            (change)="onFilesSelected($event.target.files)"
        />

        <div
            appDndDocument
            dragoverClasses="animate-pulse"
            (fileDropped)="onFilesSelected($event)"
            class="flex flex-col items-center gap-2 rounded-lg p-6 border-dashed border-2 border-info bg-info bg-opacity-20"
        >
            <iota-icon icon="cloud-arrow-up" size="3x"></iota-icon>

            <span class="text-lg" i18n>Drag file(s) here</span>
            <span class="font-light" i18n>or</span>

            <button class="btn" (click)="onSelectClick()">
                <span i18n>Choose files</span>
            </button>
        </div>

        <div *ngFor="let file of files; let i = index" class="flex flex-row items-center gap-4 mt-2">
            <img *ngIf="previewAvailable(file)" [src]="filePreviews.get(file.name)" class="w-1/4 h-auto" />

            <div class="w-1/4" *ngIf="!previewAvailable(file)">
                <iota-icon [icon]="getHeroFileIcon(file)" size="2x"> </iota-icon>
            </div>

            <span class="break-words">{{ file.name }}</span>

            <button class="btn btn-xs btn-ghost btn-circle" (click)="removeFile(index, file)">
                <iota-icon icon="x-mark" size="1.5"></iota-icon>
            </button>
        </div>
    </div>

    <div modal-footer class="flex flex-row grow justify-between items-center gap-2">
        <button class="btn" mat-dialog-close i18n>Cancel</button>
        <button class="btn btn-primary" [disabled]="!isValid()" (click)="save()" i18n>Upload files</button>
    </div>
</app-iota-modal>
